import { createHash } from "utils/helperFunctions";
import { db } from "config/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";

const removeFromWaitlist = async (
  gameId: string,
  userId: string,
): Promise<void> => {
  const gameRef = doc(db, "games", gameId);

  try {
    const docSnap = await getDoc(gameRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      const { waitlist } = data;
      const updatedWaitlist = { ...waitlist };
      delete updatedWaitlist[userId];

      console.log("player removed from waitlist");
      await updateDoc(gameRef, { waitlist: updatedWaitlist });
    }
  } catch (err) {
    console.log(err);
  }
};

const moveToWaitlist = async (reqData: any): Promise<void> => {
  const playerData = {
    id: reqData.senderId,
    displayName: reqData.senderName,
    timeStamp: Date.now(),
  };

  const gameRef = doc(db, "games", reqData.gameId);

  try {
    const docSnap = await getDoc(gameRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      const { waitlist, playerlist } = data;
      const updatedWaitlist = { ...waitlist, [playerData.id]: true };
      const updatedPlayerlist = { ...playerlist, [playerData.id]: playerData };

      await updateDoc(gameRef, {
        playerlist: updatedPlayerlist,
        waitlist: updatedWaitlist,
      });
      console.log("player moved to waitlist");
    }
  } catch (err) {
    console.warn(err);
  }
};

const addPlayerToWaitManually = async (
  gameId: string,
  playerName: string,
): Promise<{ msg: string }> => {
  if (playerName === "") {
    return { msg: "Please enter a name" };
  }
  const gameRef = doc(db, "games", gameId);
  const id = `Host${createHash(playerName)}`;
  const playerData = {
    id,
    displayName: `${playerName} (Guest)`,
    manuallyAdded: true,
    timeStamp: Date.now(),
  };

  // Add player to waitlist list
  try {
    const docSnap = await getDoc(gameRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      const { waitlist, playerlist } = data;

      if (waitlist[id]) {
        return { msg: `${playerData.displayName} is already on the waitlist` };
      }

      const updatedWaitlist = { ...waitlist, [id]: true };
      const updatedPlayerlist = { ...playerlist, [id]: playerData };
      await updateDoc(gameRef, {
        waitlist: updatedWaitlist,
        playerlist: updatedPlayerlist,
      });
      return { msg: `${playerData.displayName} added to waitlist successfully` };
    }
    return { msg: "Game not found" };
  } catch {
    return { msg: "Error adding player to waitlist" };
  }
};

export default {
  removeFromWaitlist,
  moveToWaitlist,
  addPlayerToWaitManually,
};
